/**
 * A random id that works on any page, secure or not.
 *
 * `crypto.randomUUID` exists only in secure contexts (HTTPS or localhost).
 * Anywhere else, a dev server reached over plain http on a LAN or Tailscale
 * address for instance, it is simply missing, and saving a reading threw.
 * `getRandomValues` is available everywhere, so the fallback builds a v4
 * UUID from it.
 */
export function newId(): string {
  if (typeof crypto.randomUUID === "function") return crypto.randomUUID();
  const b = crypto.getRandomValues(new Uint8Array(16));
  b[6] = (b[6] & 0x0f) | 0x40;
  b[8] = (b[8] & 0x3f) | 0x80;
  const h = Array.from(b, (x) => x.toString(16).padStart(2, "0"));
  return `${h.slice(0, 4).join("")}-${h.slice(4, 6).join("")}-${h.slice(6, 8).join("")}-${h.slice(8, 10).join("")}-${h.slice(10).join("")}`;
}
